import { Button } from "components/Button/Button";
import { ActionDropdownButton } from "components/DropdownButton/ActionDropdownButton";
import { IconLike } from "components/Icon/Icon";

interface SaveSplitButtonProps {
    canCommit: boolean;
    icon?: IconLike;
    isDisabled: boolean;
    isLoading: boolean;
    saveFormWithCommit: (canCommit: boolean) => void;
    overlayClassName?: string;
}

export const SaveSplitButton = ({
    canCommit,
    icon,
    isDisabled,
    isLoading,
    saveFormWithCommit,
    overlayClassName,
}: SaveSplitButtonProps) => {
    const getProps = (canCommit) => ({
        action: () => saveFormWithCommit(canCommit),
        label: canCommit ? "Save and commit" : "Save",
    });
    const parentProps = getProps(canCommit);
    const childProps = getProps(!canCommit);

    return (
        <ActionDropdownButton
            icon={icon}
            isDisabled={isDisabled || isLoading}
            parentAction={parentProps.action}
            label={parentProps.label}
            overlayClassName={overlayClassName}
            tooltipOverlay="Ctrl+S"
        >
            <Button
                icon={icon}
                variation="clear"
                className="wide"
                disabled={isDisabled || isLoading}
                onClick={childProps.action}
                label={childProps.label}
            />
        </ActionDropdownButton>
    );
};
